import { Scene } from "../scene";
import { SceneComponentConstants } from "../sceneComponent";
import { GeometryBufferRenderer } from "./geometryBufferRenderer";
Object.defineProperty(Scene.prototype, "geometryBufferRenderer", {
    get: function () {
        this._geometryBufferRenderer;
    },
    set: function (value) {
        if (value && value.isSupported) {
            this._geometryBufferRenderer = value;
        }
    },
    enumerable: true,
    configurable: true
});
Scene.prototype.enableGeometryBufferRenderer = function (ratio) {
    if (ratio === void 0) { ratio = 1; }
    if (this._geometryBufferRenderer) {
        return this._geometryBufferRenderer;
    }
    this._geometryBufferRenderer = new GeometryBufferRenderer(this, ratio);
    if (!this._geometryBufferRenderer.isSupported) {
        this._geometryBufferRenderer = null;
    }
    return this._geometryBufferRenderer;
};
Scene.prototype.disableGeometryBufferRenderer = function () {
    if (!this._geometryBufferRenderer) {
        return;
    }
    this._geometryBufferRenderer.dispose();
    this._geometryBufferRenderer = null;
};
/**
 * Defines the Geometry Buffer scene component responsible to manage a G-Buffer useful
 * in several rendering techniques.
 */
var GeometryBufferRendererSceneComponent = /** @class */ (function () {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */
    function GeometryBufferRendererSceneComponent(scene) {
        /**
         * The component name helpful to identify the component in the list of scene components.
         */
        this.name = SceneComponentConstants.NAME_GEOMETRYBUFFERRENDERER;
        this.scene = scene;
    }
    /**
     * Registers the component in a given scene
     */
    GeometryBufferRendererSceneComponent.prototype.register = function () {
        this.scene._gatherRenderTargetsStage.registerStep(SceneComponentConstants.STEP_GATHERRENDERTARGETS_GEOMETRYBUFFERRENDERER, this, this._gatherRenderTargets);
    };
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */
    GeometryBufferRendererSceneComponent.prototype.rebuild = function () {
        // Nothing to do for this component
    };
    /**
     * Disposes the component and the associated ressources
     */
    GeometryBufferRendererSceneComponent.prototype.dispose = function () {
        // Nothing to do for this component
    };
    GeometryBufferRendererSceneComponent.prototype._gatherRenderTargets = function (renderTargets) {
        if (this.scene._geometryBufferRenderer) {
            renderTargets.push(this.scene._geometryBufferRenderer.getGBuffer());
        }
    };
    return GeometryBufferRendererSceneComponent;
}());
export { GeometryBufferRendererSceneComponent };
GeometryBufferRenderer._SceneComponentInitialization = function (scene) {
    // Register the G Buffer component to the scene.
    var component = scene._getComponent(SceneComponentConstants.NAME_GEOMETRYBUFFERRENDERER);
    if (!component) {
        component = new GeometryBufferRendererSceneComponent(scene);
        scene._addComponent(component);
    }
};
//# sourceMappingURL=geometryBufferRendererSceneComponent.js.map